export var inputTags = {
  INPUT: true,
  TEXTAREA: true,
  SELECT: true
};
export var mutableTags = {
  INPUT: true,
  TEXTAREA: true,
  OPTION: true
};
export var textInputTypes = {
  'datetime-local': true,
  'select-multiple': true,
  'select-one': true,
  color: true,
  date: true,
  datetime: true,
  email: true,
  month: true,
  number: true,
  password: true,
  range: true,
  search: true,
  tel: true,
  text: true,
  textarea: true,
  time: true,
  url: true,
  week: true
};